export default __webpack_public_path__ + "static/media/hra_locked.48b37127.png";